import { render, staticRenderFns } from "./MedGuide.vue?vue&type=template&id=53df433c&scoped=true&"
import script from "./MedGuide.vue?vue&type=script&lang=js&"
export * from "./MedGuide.vue?vue&type=script&lang=js&"
import style0 from "./MedGuide.vue?vue&type=style&index=0&id=53df433c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53df433c",
  null
  
)

export default component.exports